var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 2.25C2.9302 2.25 2.25 2.9302 2.25 3.75V14.25C2.25 15.0698 2.9302 15.75 3.75 15.75H14.25C15.0698 15.75 15.75 15.0698 15.75 14.25V9H14.25V14.25H3.75V3.75H9V2.25H3.75ZM10.5 2.25V3.75H13.1895L6.21973 10.7197L7.28027 11.7803L14.25 4.81055V7.5H15.75V2.25H10.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnExternalLink);
export default __webpack_public_path__ + "static/media/gn-external-link.2f3a107a7fc534897421c3a00bacdb34.svg";
export { ForwardRef as ReactComponent };